module.exports = __webpack_public_path__ + "img/about-about_sec_img.b1f17c9a.png";